/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaIconDrag from 'DesignSystem/Svgs/TysiaIconDrag/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/Content/BoardItem/IconAndTitle/DragIcon/Content",
  isHovered
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<fromFlow.When is={isHovered}>
<TysiaIconDrag
  viewPath={`${viewPath}/TysiaIconDrag`}
 fill2={dtColorsNeutral500}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}